<template>
  <div>
    <div v-if="text" class="notification" :class="type">
      <div class="icon" :class="icon"></div>
      <div class="text">
        {{text}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EsimNotification",
  props: {
    text: String,
    type: String,
    icon: String,
  }
};
</script>

<style lang="scss">

.notification {
  min-height: 80px;
  display: flex;
  align-items: center;
  padding: 5px 24px;
  .icon {
    height: 24px;
    min-width: 24px;
    background-repeat: no-repeat;
    background-size: contain;

    &.check {
      background-image: url('~@/assets/default/light/esim-tick-default-light.svg');
    }
    &.info {
      background-image: url('~@/assets/default/light/message-info-default-light.svg');
    }
  }
  .text {
    white-space: pre-line;
    margin-left: 16px;
  }
  &.success {
    background-color: #E8F2EB;
    color: #1B7B3A;
  }
  &.error {
    background-color: #F7E7E9;
    color: #AF1523;
  }
  &.info {
    background-color: #DDE8F9;
    color: $black;
  }
  &.warning {
    background-color: #FBEDC9;
    color: $black;
  }
}
</style>
